import { trpc } from '@/shared/api';

/** 랜딩 히어로 이미지 목록 캐시 무효화 함수를 돌려준다. */
export const useInvalidateLandingHeroImages = (): (() => void) => {
  const utils = trpc.useUtils();

  return () => void utils.landing.listHeroImagesAdmin.invalidate();
};
